import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LightboxOverviewTyre } from './filter_views/lightbox_overview_tyre';
import { LightboxTyreIndex } from './filter_views/lightbox_tyre_index';
import { LightboxBrand } from './filter_views/lightbox_brand';
import { LightboxPrice } from './filter_views/lightbox_price';
import { LightboxDeals } from './filter_views/lightbox_deals';
import { LightboxFeatures } from './filter_views/lightbox_features';
import { LightboxTyreTechnology } from './filter_views/lightbox_tyre_technology';
import { LightboxTyreRatings } from './filter_views/lightbox_tyre_ratings';
import { LightboxCustomerReviews } from './filter_views/lightbox_customer_reviews';
import { LightboxAdditional } from './filter_views/lightbox_additional';
import { LightboxVehicleTyres } from './filter_views/lightbox_vehicle_tyres';
import { FilterSections } from '../../../constants/filter/filter_sections';
import { LightboxTyreUsage } from './filter_views/lightbox_tyre_usage';
import { Filters } from '../../../constants/filter/filters';
import { ComponentClassNames } from '../../../helper/componen_class_names';
import { featureFlags } from '../../../../_constants/feature_flags';
import LastUsedConfiguratorStore from '../../../stores/last_used_configurator_store';
import RegoLookupStore from '../../../stores/rego_lookup_store';
import VehicleFilterStore from '../../../stores/vehicle_configurator_store';
import { saveFilterInLocalStorage } from '../../../../utilities/match_catalog_filters';
import { LightboxQualitySegment } from './filter_views/lightbox_quality_segment';
import { LightboxSeason } from './filter_views/lightbox_season';
import { LightboxEv } from './filter_views/lightbox_ev';
class Tyre extends Component {
    constructor() {
        super();
        this.state = {
            lastUsedConfiguratorStore: LastUsedConfiguratorStore.getState(),
            regoLookupStore: RegoLookupStore.getState(),
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
        };
    }

    componentDidMount() {
        LastUsedConfiguratorStore.addListener(() => this._getLastUsedConfiguratorStore());
        RegoLookupStore.addListener(() => this._getRegoLookupStore());
        VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
        saveFilterInLocalStorage(this.props.filterValues);
    }

    componentWillUnmount() {
        LastUsedConfiguratorStore.addListener(() => this._getLastUsedConfiguratorStore());
        RegoLookupStore.addListener(() => this._getRegoLookupStore());
        VehicleFilterStore.addListener(() => this._getVehicleConfiguratorStore());
    }

    _getLastUsedConfiguratorStore() {
        this.setState({
            lastUsedConfiguratorStore: LastUsedConfiguratorStore.getState(),
        });
    }

    _getRegoLookupStore() {
        this.setState({
            regoLookupStore: RegoLookupStore.getState(),
        });
    }

    _getVehicleConfiguratorStore() {
        this.setState({
            vehicleConfiguratorStore: VehicleFilterStore.getState(),
        });
    }

    render() {

        const props = this.props;
        const { lastUsedConfiguratorStore } = this.state;
        const lastUsedConfigurator = lastUsedConfiguratorStore.configuratorSource;
        const sectionVisibility = props.sectionVisibility;
        const filterValues = props.filterValues;
        const filterOptions = props.filterOptions;

        const containerClasses = new ComponentClassNames('lightbox-filter');
        if (props.visible) {
            containerClasses.addClassNames('lightbox-filter--visible');
        }

        const sectionContainerClasses = new ComponentClassNames('lightbox-filter__filters-section', 'lightbox-filters-content');
        if (sectionVisibility !== '') {
            sectionContainerClasses.addClassNames('lightbox-filters-section--hide-nonactive-sections');
        }

        return (
            <div className={containerClasses.getClassName()}>
                <LightboxOverviewTyre
                    opened={sectionVisibility === ''}
                    openView={props.onShowFilterView}
                    onApplyClick={props.onApply}
                    onResetAndCloseClick={props.onResetAndCloseClick}
                    filterValues={filterValues}
                    onUnsetFilter={filterName => props.onResetFilterCompletely(filterName)}
                    filterOptions={filterOptions}
                    lastUsedConfigurator={lastUsedConfigurator}
                    displayDimensions={props.displayDimensions}
                />

                <LightboxVehicleTyres
                    opened={sectionVisibility === FilterSections.FITMENT_VIEW}
                    onChange={props.onVehicleTyreChange}
                    resetSection={() => props.onClose(FilterSections.VEHICLE_TYRES)}
                    saveSection={() => props.onSave(FilterSections.VEHICLE_TYRES)}
                />

                <LightboxTyreIndex
                    speedIndexValue={filterValues[Filters.SPEED_INDEX]}
                    loadIndexValue={filterValues[Filters.LOAD_INDEX]}
                    speedIndexOptions={filterOptions[Filters.SPEED_INDEX]}
                    loadIndexOptions={filterOptions[Filters.LOAD_INDEX]}
                    opened={sectionVisibility === FilterSections.TYRE_INDEX_VIEW}
                    onChange={props.onChangeCallback}
                    resetSection={() => props.onClose(FilterSections.TYRE_INDEX_VIEW)}
                    saveSection={() => props.onSave(FilterSections.TYRE_INDEX_VIEW)}
                />

                <LightboxBrand
                    brandValue={filterValues[Filters.MANUFACTURER]}
                    modelValue={filterValues[Filters.MODEL]}
                    brandOptions={filterOptions[Filters.MANUFACTURER]}
                    modelOptions={filterOptions[Filters.MODEL]}
                    modelOptionsLoading={filterOptions[Filters.MODEL + 'Loading']}
                    opened={sectionVisibility === FilterSections.BRAND_VIEW}
                    onChange={props.onChangeCallback}
                    resetSection={() => props.onClose(FilterSections.BRAND_VIEW)}
                    saveSection={() => props.onSave(FilterSections.BRAND_VIEW)}
                />

                <LightboxPrice
                    minPriceValue={filterValues[Filters.PRICE_MIN]}
                    maxPriceValue={filterValues[Filters.PRICE_MAX]}
                    minPriceOptions={filterOptions[Filters.PRICE_MIN]}
                    maxPriceOptions={filterOptions[Filters.PRICE_MAX]}
                    opened={sectionVisibility === FilterSections.PRICE_VIEW}
                    onChange={props.onChangeCallback}
                    currencyIsoCode={props.currencyIsoCode}
                    resetSection={() => props.onClose(FilterSections.PRICE_VIEW)}
                    saveSection={() => props.onSave(FilterSections.PRICE_VIEW)}
                />

                {featureFlags.FEATURE_TYRE_DEALS &&
                    <LightboxDeals
                        freeFittingEnabled={props.conditionalFilters[Filters.FREE_FITTING]}
                        buy4Pay3Enabled={props.conditionalFilters[Filters.BUY_4_PAY_3]}
                        clearanceEnabled={props.conditionalFilters[Filters.CLEARANCE]}
                        instantCashEnabled={props.conditionalFilters[Filters.INSTANT_CASH]}
                        discountInstantCash50Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_50]}
                        discountInstantCash80Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_80]}
                        discountInstantCash100Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_100]}
                        discountInstantCash120Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_120]}
                        discountInstantCash150Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_150]}
                        discountInstantCash160Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_160]}
                        discountInstantCash200Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_200]}
                        discountInstantCash250Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_250]}
                        discountInstantCash300Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_300]}
                        discount5OffEnabled={props.conditionalFilters[Filters.DISCOUNT_5_OFF]}
                        discount10OffEnabled={props.conditionalFilters[Filters.DISCOUNT_10_OFF]}
                        discount15OffEnabled={props.conditionalFilters[Filters.DISCOUNT_15_OFF]}
                        discount20OffEnabled={props.conditionalFilters[Filters.DISCOUNT_20_OFF]}
                        discount25OffEnabled={props.conditionalFilters[Filters.DISCOUNT_25_OFF]}
                        promoGiftCard50Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_50]}
                        promoGiftCard80Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_80]}
                        promoGiftCard100Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_100]}
                        promoGiftCard130Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_130]}
                        promoGiftCard150Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_150]}
                        promoGiftCard200Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_200]}
                        promoGiftCard250Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_250]}
                        freeFittingValue={!!filterValues[Filters.FREE_FITTING]}
                        buy4Pay3Value={!!filterValues[Filters.BUY_4_PAY_3]}
                        clearanceValue={!!filterValues[Filters.CLEARANCE]}
                        instantCashValue={!!filterValues[Filters.INSTANT_CASH]}
                        discountInstantCash50Value={!!filterValues[Filters.DISCOUNT_INSTANT_CASH_50]}
                        discountInstantCash80Value={!!filterValues[Filters.DISCOUNT_INSTANT_CASH_80]}
                        discountInstantCash100Value= {!!filterValues[Filters.DISCOUNT_INSTANT_CASH_100]}
                        discountInstantCash120Value= {!!filterValues[Filters.DISCOUNT_INSTANT_CASH_120]}
                        discountInstantCash150Value= {!!filterValues[Filters.DISCOUNT_INSTANT_CASH_150]}
                        discountInstantCash160Value= {!!filterValues[Filters.DISCOUNT_INSTANT_CASH_160]}
                        discountInstantCash200Value= {!!filterValues[Filters.DISCOUNT_INSTANT_CASH_200]}
                        discountInstantCash250Value= {!!filterValues[Filters.DISCOUNT_INSTANT_CASH_250]}
                        discountInstantCash300Value= {!!filterValues[Filters.DISCOUNT_INSTANT_CASH_300]}
                        discount5OffValue= {!!filterValues[Filters.DISCOUNT_5_OFF]}
                        discount10OffValue= {!!filterValues[Filters.DISCOUNT_10_OFF]}
                        discount15OffValue= {!!filterValues[Filters.DISCOUNT_15_OFF]}
                        discount20OffValue= {!!filterValues[Filters.DISCOUNT_20_OFF]}
                        discount25OffValue= {!!filterValues[Filters.DISCOUNT_25_OFF]}
                        promoGiftCard50Value={!!filterValues[Filters.PROMO_GIFT_CARD_50]}
                        promoGiftCard80Value={!!filterValues[Filters.PROMO_GIFT_CARD_80]}
                        promoGiftCard100Value={!!filterValues[Filters.PROMO_GIFT_CARD_100]}
                        promoGiftCard130Value={!!filterValues[Filters.PROMO_GIFT_CARD_130]}
                        promoGiftCard150Value={!!filterValues[Filters.PROMO_GIFT_CARD_150]}
                        promoGiftCard200Value={!!filterValues[Filters.PROMO_GIFT_CARD_200]}
                        promoGiftCard250Value={!!filterValues[Filters.PROMO_GIFT_CARD_250]}
                        opened={sectionVisibility === FilterSections.DEALS_VIEW}
                        onChange={props.onChangeCallback}
                        resetSection={() => props.onClose(FilterSections.DEALS_VIEW)}
                        saveSection={() => props.onSave(FilterSections.DEALS_VIEW)}
                    />
                }

                <LightboxFeatures
                    runflatEnabled={props.conditionalFilters[Filters.RUN_FLAT]}
                    runflatValue={!!filterValues[Filters.RUN_FLAT]}
                    onChange={props.onChangeCallback}
                    opened={sectionVisibility === FilterSections.FEATURES_VIEW}
                    resetSection={() => props.onClose(FilterSections.FEATURES_VIEW)}
                    saveSection={() => props.onSave(FilterSections.FEATURES_VIEW)}
                />

                <LightboxQualitySegment
                    qualitySegmentPremiumEnabled={props.conditionalFilters[Filters.QUALITY_SEGMENT_PREMIUM]}
                    qualitySegmentValueEnabled={props.conditionalFilters[Filters.QUALITY_SEGMENT_VALUE]}
                    qualitySegmentBudgetEnabled={props.conditionalFilters[Filters.QUALITY_SEGMENT_BUDGET]}
                    qualitySegmentPremiumValue={!!filterValues[Filters.QUALITY_SEGMENT_PREMIUM]}
                    qualitySegmentValueValue={!!filterValues[Filters.QUALITY_SEGMENT_VALUE]}
                    qualitySegmentBudgetValue={!!filterValues[Filters.QUALITY_SEGMENT_BUDGET]}
                    onChange={props.onChangeCallback}
                    opened={sectionVisibility === FilterSections.QUALITY_SEGMENT_VIEW}
                    resetSection={() => props.onClose(FilterSections.QUALITY_SEGMENT_VIEW)}
                    saveSection={() => props.onSave(FilterSections.QUALITY_SEGMENT_VIEW)}
                />

                <LightboxCustomerReviews
                    customerReviewDryTractionRatingAvgGroupValue={filterValues[Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP].toString()}
                    customerReviewDryTractionRatingAvgGroupOptions={filterOptions[Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP]}
                    customerReviewLowNoiseRatingAvgGroupValue={filterValues[Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP].toString()}
                    customerReviewLowNoiseRatingAvgGroupOptions={filterOptions[Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP]}
                    customerReviewRideComfortRatingAvgGroupValue={filterValues[Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP].toString()}
                    customerReviewRideComfortRatingAvgGroupOptions={filterOptions[Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP]}
                    customerReviewSteeringResponseAvgGroupValue={filterValues[Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP].toString()}
                    customerReviewSteeringResponseAvgGroupOptions={filterOptions[Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP]}
                    customerReviewTreadWearAvgGroupValue={filterValues[Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP].toString()}
                    customerReviewTreadWearAvgGroupOptions={filterOptions[Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP]}
                    customerReviewValueForMoneyAvgGroupValue={filterValues[Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP].toString()}
                    customerReviewValueForMoneyAvgGroupOptions={filterOptions[Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP]}
                    customerReviewWetTractionRatingAvgGroupValue={filterValues[Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP].toString()}
                    customerReviewWetTractionRatingAvgGroupOptions={filterOptions[Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP]}
                    opened={sectionVisibility === FilterSections.CUSTOMER_REVIEWS_VIEW}
                    onChange={props.onChangeCallback}
                    resetSection={() => props.onClose(FilterSections.CUSTOMER_REVIEWS_VIEW)}
                    saveSection={() => props.onSave(FilterSections.CUSTOMER_REVIEWS_VIEW)}
                />

                <LightboxTyreRatings
                    utqgTreadwearGroupValue={filterValues[Filters.UTQG_TREADWEAR_GROUP].toString()}
                    utqgTreadwearGroupOptions={filterOptions[Filters.UTQG_TREADWEAR_GROUP]}
                    utqgTractionValue={filterValues[Filters.UTQG_TRACTION]}
                    utqgTractionOptions={filterOptions[Filters.UTQG_TRACTION]}
                    utqgTemperatureValue={filterValues[Filters.UTQG_TEMPERATURE]}
                    utqgTemperatureOptions={filterOptions[Filters.UTQG_TEMPERATURE]}
                    labelNoiseValue={filterValues[Filters.LABEL_NOISE].toString()}
                    labelNoiseOptions={filterOptions[Filters.LABEL_NOISE]}
                    labelWetGripValue={filterValues[Filters.LABEL_WET_GRIP]}
                    labelWetGripOptions={filterOptions[Filters.LABEL_WET_GRIP]}
                    labelFuelEfficiencyValue={filterValues[Filters.LABEL_FUEL_EFFICIENCY]}
                    labelFuelEfficiencyOptions={filterOptions[Filters.LABEL_FUEL_EFFICIENCY]}
                    opened={sectionVisibility === FilterSections.TYRE_RATINGS_VIEW}
                    onChange={props.onChangeCallback}
                    resetSection={() => props.onClose(FilterSections.TYRE_RATINGS_VIEW)}
                    saveSection={() => props.onSave(FilterSections.TYRE_RATINGS_VIEW)}
                />

                <LightboxSeason
                    value={filterValues[Filters.SEASON]}
                    options={filterOptions[Filters.SEASON]}
                    opened={sectionVisibility === FilterSections.SEASON_VIEW}
                    onChange={props.onChangeCallback}
                    resetSection={() => props.onClose(FilterSections.SEASON_VIEW)}
                    saveSection={() => props.onSave(FilterSections.SEASON_VIEW)}
                />

                <LightboxEv
                    value={filterValues[Filters.EV]}
                    options={filterOptions[Filters.EV]}
                    opened={sectionVisibility === FilterSections.EV_VIEW}
                    onChange={props.onChangeCallback}
                    resetSection={() => props.onClose(FilterSections.EV_VIEW)}
                    saveSection={() => props.onSave(FilterSections.EV_VIEW)}
                />

                <LightboxTyreTechnology
                    value={filterValues[Filters.TECHNOLOGY]}
                    options={filterOptions[Filters.TECHNOLOGY]}
                    opened={sectionVisibility === FilterSections.TECHNOLOGY_VIEW}
                    onChange={props.onChangeCallback}
                    resetSection={() => props.onClose(FilterSections.TECHNOLOGY_VIEW)}
                    saveSection={() => props.onSave(FilterSections.TECHNOLOGY_VIEW)}
                />

                <LightboxTyreUsage
                    value={filterValues[Filters.USAGE]}
                    options={filterOptions[Filters.USAGE]}
                    opened={sectionVisibility === FilterSections.USAGE_VIEW}
                    onChange={props.onChangeCallback}
                    resetSection={() => props.onClose(FilterSections.USAGE_VIEW)}
                    saveSection={() => props.onSave(FilterSections.USAGE_VIEW)}
                />

                <LightboxAdditional
                    vehicleTypeValue={filterValues[Filters.VEHICLE_TYPE]}
                    vehicleTypeOptions={filterOptions[Filters.VEHICLE_TYPE]}
                    opened={sectionVisibility === FilterSections.ADDITIONAL_VIEW}
                    onChange={props.onChangeCallback}
                    resetSection={() => props.onClose(FilterSections.ADDITIONAL_VIEW)}
                    saveSection={() => props.onSave(FilterSections.ADDITIONAL_VIEW)}
                />
            </div>
        );
    }
}

Tyre.propTypes = {
    displayDimensions: PropTypes.string,
    currencyIsoCode: PropTypes.string.isRequired,
    sectionVisibility: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    filterValues: PropTypes.object.isRequired,
    filterOptions: PropTypes.object.isRequired,
    conditionalFilters: PropTypes.object.isRequired,
    onShowFilterView: PropTypes.func.isRequired,
    onChangeCallback: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onApply: PropTypes.func.isRequired,
    onResetAndCloseClick: PropTypes.func.isRequired,
    onResetFilterCompletely: PropTypes.func.isRequired,
    onVehicleTyreChange: PropTypes.func.isRequired,
};

export { Tyre };
